import { render, staticRenderFns } from "./4mAction.vue?vue&type=template&id=b5432b72"
import script from "./4mAction.vue?vue&type=script&lang=js"
export * from "./4mAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5432b72')) {
      api.createRecord('b5432b72', component.options)
    } else {
      api.reload('b5432b72', component.options)
    }
    module.hot.accept("./4mAction.vue?vue&type=template&id=b5432b72", function () {
      api.rerender('b5432b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/action/4mAction.vue"
export default component.exports